// String used to determine if a file or attachment is stored locally
export const CONTENT_LOCATION_LOCAL_FILE = 'local';
